# frozen_string_literal: true

module Engine
  module Game
    module G1817WO
    end
  end
end
